import React from 'react'
import { cx } from '@emotion/css'
import Image from 'next/image'
import styles from './styles'

const HiringSection = () => (
  <>
    <div className={styles.hiringContainer}>
      <div className={styles.headerText}>
        <h2 className={styles.title}>Why OfferZen is Different</h2>
        <p className={styles.subText}>OfferZen is a developer job marketplace where hiring teams...</p>
        <div className={styles.cardContainer}>
          <div className={styles.cardBlock}>
            <h3>Browse curated profiles at a glance</h3>
            <div className={styles.imageContainer}>
              <Image
                src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/hiring_section/hiring1.png`}
                alt="Full Stack Engineer Offerzen Card"
                className={styles.cardImage}
                width={296}
                height={160}
                sizes="100vw"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </div>
            <p className={styles.cardText}>
              OfferZen developer profiles are standardised and curated by our team so you get upfront information on candidate experience,
              skills, salary, visa status, and career goals from the get-go.
            </p>
            <p className={styles.cardText}>
              <img
                className={styles.cardIcon}
                src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/hiring_section/world.svg`}
                alt="World Icon"
              />
              You see visa status upfront.
            </p>
          </div>

          <div className={styles.cardBlock}>
            <h3>Directly connect with responsive candidates</h3>
            <div className={styles.imageContainer}>
              <Image
                src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/hiring_section/hiring2.png`}
                alt="Interview Request Example"
                className={styles.cardImage}
                width={317}
                height={176}
                sizes="100vw"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </div>
            <p className={styles.cardText}>Directly reach out to your favourite candidates. 99% of candidates respond within 48 hours</p>
          </div>

          <div className={cx(styles.cardBlock, styles.noBorder)}>
            <h3>Seamlessly source, interview, and hire</h3>
            <div className={styles.imageContainer}>
              <Image
                src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/hiring_section/hiring3.png`}
                alt="Fill Your Open Position"
                className={styles.cardImage}
                width={295}
                height={161}
                sizes="100vw"
                style={{
                  width: '100%',
                  height: 'auto',
                }}
              />
            </div>
            <p className={styles.cardText}>
              Shortlist candidates, schedule interviews, review your pipeline, and collaborate with your team all in one place.
            </p>
            <p className={styles.cardText}>
              <img
                className={styles.cardIcon}
                src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/hiring_section/greenhouse.svg`}
                alt="Greenhouse Icon"
              />
              Greenhouse integration supported.
            </p>
          </div>
        </div>
      </div>
    </div>
  </>
)

export default HiringSection
